import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Css from './PlaneDetails.scss';
import HorizontalSlider from '@components/HorizontalSlider/HorizontalSlider';

class PlaneDetails extends Component {
  state = {
    showItem: false
  };

  showDetailsHandler = itemName => {
    this.setState({
      showItem: itemName
    });
  };

  render() {
    return (
      <div>
        <div
          className={Css['expand-item'] + ' py-3 px-4'}
          onClick={() => this.showDetailsHandler('gallery')}
        >
          <span>Gallery</span>
          {this.state.showItem === 'gallery' ? (
            <FontAwesomeIcon
              icon={['fas', 'minus']}
              className={'float-right mt-1'}
            />
          ) : (
            <FontAwesomeIcon
              icon={['fas', 'plus']}
              className={'float-right mt-1'}
            />
          )}

          {this.state.showItem === 'gallery' && (
            <div className={'pt-3'}>
              <HorizontalSlider {...this.props} />
            </div>
          )}
        </div>
        <div
          className={Css['expand-item'] + ' py-3 px-4'}
          onClick={() => this.showDetailsHandler('overview')}
        >
          <span>Overview</span>
          {this.state.showItem === 'overview' ? (
            <FontAwesomeIcon
              icon={['fas', 'minus']}
              className={'float-right mt-1'}
            />
          ) : (
            <FontAwesomeIcon
              icon={['fas', 'plus']}
              className={'float-right mt-1'}
            />
          )}

          {this.state.showItem === 'overview' && (
            <div className={'pt-3'} style={{ margin: '0px -30px' }}>
              <table className={'table'} cellSpacing={10}>
                <thead>
                  <tr>
                    <th className={'header-red'}>Category</th>
                    <th className={'header-grey'}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.overview.map((row, i) => {
                    return (
                      <tr key={i}>
                        <td>{row.title}</td>
                        <td dangerouslySetInnerHTML={{ __html: row.content }} />
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div
          className={Css['expand-item'] + ' py-3 px-4'}
          onClick={() => this.showDetailsHandler('performance')}
        >
          <span>Performance</span>
          {this.state.showItem === 'performance' ? (
            <FontAwesomeIcon
              icon={['fas', 'minus']}
              className={'float-right mt-1'}
            />
          ) : (
            <FontAwesomeIcon
              icon={['fas', 'plus']}
              className={'float-right mt-1'}
            />
          )}

          {this.state.showItem === 'performance' && (
            <div className={'pt-3'} style={{ margin: '0px -30px' }}>
              <img
                src={this.props.performance}
                alt={'Performance'}
                className={'img-fluid'}
              />
            </div>
          )}
        </div>

        <div
          className={Css['expand-item'] + ' py-3 px-4'}
          onClick={() => this.showDetailsHandler('range-maps')}
        >
          <span>Range Map</span>
          {this.state.showItem === 'range-maps' ? (
            <FontAwesomeIcon
              icon={['fas', 'minus']}
              className={'float-right mt-1'}
            />
          ) : (
            <FontAwesomeIcon
              icon={['fas', 'plus']}
              className={'float-right mt-1'}
            />
          )}

          {this.state.showItem === 'range-maps' && (
            <div className={'pt-3'} style={{ margin: '0px -30px' }}>
              <img
                src={this.props.rangeMap}
                alt={'Range Map'}
                className={'img-fluid d-block mx-auto py-2'}
              />
              <div className={'color-red font-xs text-center asap-regular'}>
                {this.props.header === 'Phenom 100' && (
                  <div className={Css['plane-table-description']}>
                    * RANGE MAP SHOWN IS FOR ILLUSTRATIVE PURPOSES ONLY. ALL
                    FLIGHTS ARE SUBJECT TO JETSUITE FLIGHT OPERATIONS.
                  </div>
                )}
                {this.props.header !== 'Phenom 100' && (
                  <div className={Css['plane-table-description']}>
                    * RANGE MAPS SHOWN ARE FOR ILLUSTRATIVE PURPOSES ONLY. ALL
                    FLIGHTS ARE SUBJECT TO JETSUITE FLIGHT OPERATIONS.
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        <div
          className={Css['expand-item'] + ' py-3 px-4'}
          onClick={() => this.showDetailsHandler('configuration')}
        >
          <span>Configuration</span>
          {this.state.showItem === 'configuration' ? (
            <FontAwesomeIcon
              icon={['fas', 'minus']}
              className={'float-right mt-1'}
            />
          ) : (
            <FontAwesomeIcon
              icon={['fas', 'plus']}
              className={'float-right mt-1'}
            />
          )}

          {this.state.showItem === 'configuration' && (
            <div className={'pt-3'} style={{ margin: '0px -30px' }}>
              <img
                src={this.props.lopa}
                alt={'Lopa'}
                className={'img-fluid d-block mx-auto py-2'}
              />
              <div className={'color-red font-xs text-center asap-regular'}>
                * CONFIGURATION IS SHOWN FOR ILLUSTRATIVE PURPOSES ONLY.
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default PlaneDetails;



// WEBPACK FOOTER //
// ./src/components/OurAircraft/List/PlaneDetails/PlaneDetails.js